import $ from 'jquery';
import product from '../../api/product';
import recentlyViewedProducts from '../../smartpak/recentlyviewedproducts';

const trends = {
    trendsContent: function(el) {
        var isPerksEligible =
            smartPak.cdProfileCookie.HasSmartPerksPromo && smartPak.smartPrimeCookie.PerksEligible === 'True',
            products = $(el);

        // Add the prices
        function modifyContent(id) {
            product.getProductClass(id).done(function(data) {
                // Get the data (all: console.log(data) )
                // Add the price range
                $('#product-' + id + ' .product-price span').html(
                    isPerksEligible ? data.Content.Price : data.Content.Prices[0].Price
                );
                // Add the description to the modal
                $('#productModal-' + id + ' .product-description').html(data.Content.ShortDescription);
            });
        }

        // Loop through all the products and add content
         
        for (var p = 0; p < products.length; p++) {
            let thisId = parseInt(
                $(products[p])
                    .attr('id')
                    .replace('product-', '')
            );
            // Add the price range & add the description to the modal
            modifyContent(thisId);
        }
    },

    trendsModal: function(el) {
        // When clicking on a product modal link
        $(el).on('click', '.product-modal', function(event) {
            var link = $(event.currentTarget), // The link
                content = $('#productModal-' + link.data('id')).get(0); // Grab the modal content

            // Launch the modal
            smartPak.ui.modal(content, {
                modal: true,
                resizable: false,
                title: 'Product Details',
                width: 650
            });
        });
    },

    init: function() {
        recentlyViewedProducts.loadBvReviewStars('.trendsReviewStars');
        this.trendsModal('.product-grid');
        this.trendsContent('.product');
    }
};

export default trends;